import { render } from "./BoardTotalSales.vue?vue&type=template&id=4f408d14&scoped=true"
import script from "./BoardTotalSales.vue?vue&type=script&lang=js"
export * from "./BoardTotalSales.vue?vue&type=script&lang=js"

import "./BoardTotalSales.vue?vue&type=style&index=0&id=4f408d14&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f408d14"]])

export default __exports__